/** @format */

import { IColorDefault, IFontSize } from "types/theme";

export const defaultColorTheme: IColorDefault = {
  primary: "#f08c81",
  third: "#FFD8D4",
  secondary: "#ffffff",
  textMain: "#373737",
  textGray: "#858585",
  warning: "#FFA500",
  success: "#28A745",
  info: "#17A2B8",
  error: "#DC3545",
};

export const mainColor: IColorDefault = {
  primary: "#f08c81",
  third: "#FFD8D4",
  secondary: "#ffffff",
  textMain: "#373737",
  textGray: "#858585",
  warning: "#FFA500",
  success: "#28A745",
  info: "#17A2B8",
  error: "#DC3545",
};

export const fontSize: IFontSize = {
  xs: "12px",
  sm: "14px",
  md: "18px",
  xl: "24px",
};
